<p-dataView *ngIf="dataView" #dv [value]="products" [paginator]="true" [rows]="9" filterBy="name" layout="grid">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
            <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                <i class="pi pi-search"></i>
                <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
            </span>
            <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="list">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="assestBaseUrl + 'images/' + product.img"   [alt]="product.name" />
                            <div class="p-mt-2"><strong>{{product.name}}</strong></div>
                        </div>
                        <div class="p-d-flex p-flex-column p-text-right">
                            <div>
                                <p-button label="Install Now" (click)="installBtn(product)" *ngIf="!product.installed && !product.showSpin"></p-button>
                                <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                                <p-button icon="pi pi-check" (click)="uninstallBtn(product)" *ngIf="product.installed"></p-button>
                            </div>
                            <p-button class="p-mt-auto" label="Details" (click)="changeTableView(product)" *ngIf="product.showDetailBtn"></p-button>
                        </div>
                    </div>
                    <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                        {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="grid">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12 p-md-4">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="assestBaseUrl + 'images/' + product.img" [alt]="product.name" />
                            <div class="p-mt-2"><strong>{{product.name}}</strong></div>
                        </div>
                        <div>
                            <p-button label="Install Now" (click)="installBtn(product)" *ngIf="!product.installed && !product.showSpin"></p-button>
                            <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                            <p-button icon="pi pi-check" (click)="uninstallBtn(product)" *ngIf="product.installed"></p-button>
                        </div>
                    </div>
                    <div class="p-d-flex p-jc-between">
                        <div class="p-my-2 leaddescName" (click)="showMoreInfo(product)">
                            {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                        </div>
                        <div>
                            <p-button label="Details" (click)="changeTableView(product)" *ngIf="product.showDetailBtn"></p-button>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
</p-dataView>
<ng-container *ngIf="!dataView && selectedData == 'desktop'">
    <p-table [value]="qbDesktopDetails?.qbWarehouseMapping">
        <ng-template pTemplate="caption">
            <div class="table-header p-d-flex">
                <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
                <h5 class="p-ml-3 p-mt-1" style="flex-grow: 1;">
                    Quickbooks Desktop -
                    <span *ngIf="!showMultiple">Single Warehouse</span>
                    <span *ngIf="showMultiple">Multi Warehouses</span>
                    <span *ngIf="showMultiple" class="btnBars p-ml-2" (click)="editQBMode()">
                <i class="pi pi-pencil"></i>
              </span>
                </h5>
                <p-button icon="pi pi-table" (click)="showMappingData()" pTooltip="More info" tooltipPosition="top" class="p-mr-2"></p-button>
                <p-button icon="pi pi-clock" (click)="editSchedule()" pTooltip="Schedule" tooltipPosition="top" *ngIf="qbDesktopDetails?.isScheduled==false" class="p-mr-2"></p-button>
                <p-button icon="pi pi-play" (click)="editSchedule()" pTooltip="Resume" tooltipPosition="top" *ngIf="qbDesktopDetails?.isScheduled==true && qbDesktopDetails?.pausedOn==null" class="p-mr-2"></p-button>
                <p-button icon="pi pi-pause" (click)="editSchedule()" pTooltip="Pause" tooltipPosition="top" *ngIf="qbDesktopDetails?.isScheduled==true && qbDesktopDetails?.pausedOn!=null" class="p-mr-2"></p-button>
                <p-button icon="pi pi-key" (click)="editConnect()" pTooltip="Key" tooltipPosition="top" class="p-mr-2"></p-button>
                <p-button icon="pi pi-plus" (click)="addDesktopData()" *ngIf="showMultiple"></p-button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>LionO location Name</th>
                <th>QB Warehouse Name</th>
                <th>Is Active</th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{data.warehouseName}}</td>
                <td>{{data.qbWarehouseName}}</td>
                <td>{{data.statusId==1?'Yes':'No'}}</td>
                <td class="action">
                    <span class="btnBars p-mr-0" pTooltip="Edit" (click)="editMultipleData(data)" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="p-text-center p-mt-5">
        <p-button *ngIf="!showMultiple" label="Upgrade to multi warehouse" (click)="openSetup()"></p-button>
    </div>
</ng-container>
<ng-container *ngIf="!dataView && selectedData == 'online'">
    <p-table [value]="qbDesktopDetails?.qbWarehouseMapping">
        <ng-template pTemplate="caption">
            <div class="table-header p-d-flex">
                <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
                <h5 class="p-ml-3 p-mt-1" style="flex-grow: 1;">Quickbooks Online</h5>
                <p-button icon="pi pi-plus" (click)="addSingleData()"></p-button>
                <p-button *ngIf="!isQBOnlineConnected" (click)="onClickQBOnlineConnectBtn()">Connect</p-button>
                <p-button *ngIf="isQBOnlineConnected" (click)="onClickQBOnlineDisconnectBtn()">Disconnect</p-button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>LionO location Name</th>
                <th>QB Warehouse Name</th>
                <th>Is Active</th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{data?.warehouseName}}</td>
                <td>{{data?.qbWarehouseName}}</td>
                <td>{{data?.statusId ==1 ?'Yes' : 'No'}}</td>
                <td class="action">
                    <span class="btnBars p-mr-0" pTooltip="Edit" (click)="editSingleData(product)" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                    <span class="btnBars p-mr-0" pTooltip="More info" (click)="showMappingData()" tooltipPosition="top"><i class="pi pi-table"></i></span>
                    <span class="btnBars p-mr-0" pTooltip="Schedule" (click)="editSchedule()" tooltipPosition="top">
                  <i class="pi pi-clock" *ngIf="ScheduleOptions == null || ScheduleOptions == ''"></i>
                  <i class="pi pi-play" *ngIf="ScheduleOptions == 'Resume'"></i>
                  <i class="pi pi-pause" *ngIf="ScheduleOptions == 'Pause'"></i>
                </span>
                    <span class="btnBars p-mr-0" pTooltip="Set up" tooltipPosition="top"><i class="pi pi-cog"></i></span>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div style="margin-top: 40px;">
        <p-button (click)="savePaymentTerm()" [style]="{margin: '10px'}">Payment Term</p-button>
        <p-button (click)="savePaymentMethod()" [style]="{margin: '10px'}">Payment Method</p-button>
        <p-button (click)="saveProduct()" [style]="{margin: '10px'}">Product</p-button>
        <p-button (click)="saveInvoice()" [style]="{margin: '10px'}">Invoice</p-button>
        <p-button (click)="saveReceivePayment()" [style]="{margin: '10px'}">Receive Payments</p-button>
        <p-button (click)="addAccountsToQB()" [style]="{margin: '10px'}">Add Accounts to QB</p-button>
        <p-button (click)="addAccountsToLionO()" [style]="{margin: '10px'}">Add Accounts to LionO</p-button>
        <p-button (click)="addVendorToQB()" [style]="{margin: '10px'}">Add Vendors to QB</p-button>
        <p-button (click)="addVendorToLionO()" [style]="{margin: '10px'}">Add Vendors to LionO</p-button>
        <p-button (click)="addBillsToQB()" [style]="{margin: '10px'}">Add Bills to QB</p-button>
        <p-button (click)="addBillPaymentToLionO()" [style]="{margin: '10px'}">Add Bill payment to LionO</p-button>
        <!-- <p-button (click)="addProductAsServiceToLionO()" [style]="{margin: '10px'}">Add Product as Service To LionO</p-button> -->
        <p-button (click)="addServiceAsProducts()" [style]="{margin: '10px'}">Add Service as Products To LionO</p-button>
    </div>
</ng-container>

<p-dialog header="{{addEditSingleDataHeader}}" [(visible)]="displayAddEditSingleData" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="header">
        <h5>QB Information
            <p-inputSwitch class="header-switch" [(ngModel)]="qbSingleTemp.isActive"></p-inputSwitch>
        </h5>
    </div>
    <div class="card">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <label>Location</label>
                <p-dropdown appendTo="body" optionLabel="name" [options]="allLocations" [ngModelOptions]="{standalone: true}" placeholder="Select location" [(ngModel)]="selectedLocation"></p-dropdown>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayAddEditSingleData=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save"></button>
    </p-footer>
</p-dialog>
<p-dialog header="{{addEditDesktopDataHeader}}" [(visible)]="displayAddEditDesktopData" [modal]="true" [responsive]="true" [style]="{width: '60vw'}" (onHide)="warehouseForm.reset()">
    <form [formGroup]="warehouseForm">
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Location</label>
                    <p-dropdown appendTo="body" optionLabel="name" [options]="warehouseList" placeholder="Select location" formControlName="warehouseId" [filter]="true"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6" *ngIf="qbDesktopDetails?.warehouseIntegrationType=='Single Warehouse'">
                    <label>QB Warehouse</label>
                    <h5>{{warehouseForm.controls['qbWarehouseName']?.value}}</h5>
                </div>
                <div class="p-col-12 p-md-6" *ngIf="qbDesktopDetails?.warehouseIntegrationType=='Multi Warehouse'">
                    <label>QB Warehouse</label>
                    <p-dropdown appendTo="body" optionLabel="name" [options]="QBWarehouseList" placeholder="Select warehouse" formControlName="qbWarehouseId"></p-dropdown>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayAddEditDesktopData=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="saveWarehouseData(warehouseForm.value)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Field Mappings" [(visible)]="displayMoreData" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p-table [value]="mappingData">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th>Sync Direction</th>
                            <th>is Active</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-map>
                        <tr>
                            <td>{{map.objectData}}</td>
                            <td>{{map.syncType}}</td>
                            <td>{{map.statusId==1?'Yes':'No'}}</td>
                            <td class="action">
                                <span class="btnBars p-mr-0" pTooltip="Edit" (click)="editMapping(map)" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                <span class="btnBars p-mr-0" pTooltip="Field mapping" (click)="confirmMapping()" tooltipPosition="top"><i class="pi pi-briefcase"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayMoreData=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="updateMappingData()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Edit Field Mapping" [(visible)]="displayEditMapping" [modal]="true" [responsive]="true" [style]="{width: '60vw'}" (onHide)="fieldMappingForm.reset()">
    <form [formGroup]="fieldMappingForm">
        <div class="header">
            <h5>Field Mapping Information
                <p-inputSwitch class="header-switch" formControlName="statusId"></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Name</label>
                    <input type="text" pInputText formControlName="objectData" disabled>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Sync Direction</label>
                    <p-dropdown appendTo="body" optionLabel="name" [options]="allDirections" [ngModelOptions]="{standalone: true}" placeholder="Select sync direction" formControlName="syncFromTypeId"></p-dropdown>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayEditMapping=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="updateSyncData(fieldMappingForm.value)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Field Mapping" [(visible)]="displayFieldMapping" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-grid" *ngFor="let section of lionOFields; let i = index">
            <div class="p-col-12">
                <div class="p-grid" *ngIf="i == 0">
                    <h6 class="p-col p-pl-4">Label Name</h6>
                    <h6 class="p-col p-mb-2">Edit Label Name</h6>
                    <h6 class="p-col-fixed p-mb-2 p-pl-4" style="width:80px">Sync</h6>
                </div>
                <p-table [value]="section.fields" dataKey="id" styleClass="editable" [(selection)]="selectedRowDataArray">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="header p-col-5">
                                <h5>{{section.name}}</h5>
                            </th>
                            <th class="header"></th>
                            <th class="header p-text-center" style="width:80px">
                                <p-checkbox [ngModelOptions]="{standalone: true}" (onChange)="selectSectionHeader($event,i)" #ct1 ngDefaultControl [(ngModel)]="selectedSectionHeader[i]" binary="true"></p-checkbox>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-label let-expanded="expanded">
                        <tr>
                            <td>{{label.name}}
                                <span style="color: red;" *ngIf="label.isrequired">*</span>
                                <button type="button" pButton pRipple [pRowToggler]="label" style="width: 1.25rem;height: 1.25rem;" class="p-button-text p-button-rounded p-p-0 p-ml-2" [icon]="expanded ? 'pi pi-minus' : 'pi pi-plus'" *ngIf="label.fieldTypes && label.fieldTypes.fields && label.fieldTypes.fields.length"></button>
                            </td>
                            <td pEditableColumn class="action">
                                <p-dropdown appendTo="body" optionLabel="name" [options]="QBFields" [ngModelOptions]="{standalone: true}" placeholder="Select QB Fields"></p-dropdown>
                            </td>
                            <td class="p-text-center action">
                                <p-checkbox [ngModelOptions]="{standalone: true}" (click)="syncHeaderCheckBox(i)" [disabled]="label.movable" [value]="label" ngDefaultControl [(ngModel)]="label.ischecked" binary="true"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-label>
                        <tr *ngFor="let s of label.fieldTypes?.fields" class="child-color">
                            <td>{{s.name}}</td>
                            <td pEditableColumn class="action">
                                <input pInputText type="text" [ngModelOptions]="{standalone:true}" [(ngModel)]="s.labelname">
                            </td>
                            <td class="p-text-center action">
                                <p-checkbox [ngModelOptions]="{standalone: true}" (click)="syncHeaderCheckBox(i)" [disabled]="label.movable" [value]="label" ngDefaultControl [(ngModel)]="s.ischecked" binary="true"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayFieldMapping=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Connection String" [(visible)]="displayConnection" [modal]="true" [responsive]="true" [style]="{width: '60vw'}" (onHide)="connectForm.reset()">
    <form [formGroup]="connectForm">
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Client ID</label>
                    <div class="p-d-flex  p-jc-between">
                        <input #clientId type="text" pInputText formControlName="clientId" style="opacity: 1;" disabled/>
                        <p-button icon="pi pi-copy" pTooltip="Copy" tooltipPosition="top" class="p-ml-2" (click)="copyInputMessage(clientId)"></p-button>
                    </div>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Auth Token</label>
                    <div class="p-d-flex  p-jc-between">
                        <input #token type="text" disabled pInputText formControlName="authToken" style="opacity: 1;" />
                        <p-button icon="pi pi-copy" pTooltip="Copy" tooltipPosition="top" class="p-ml-2" (click)="copyInputMessage(token)"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <p-footer>
        <button type="button" pButton (click)="displayConnection=false" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Resume or Pause Sync" [(visible)]="displaySchedule" [modal]="true" [responsive]="true" [style]="{width: '60vw'}" (onHide)="schedularForm.reset()">
    <form [formGroup]="schedularForm">
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <div class="p-field-radiobutton">
                        <p-radioButton [disabled]="qbDesktopDetails?.isSecheduled &&qbDesktopDetails?.pausedOn==null" value="Resume" formControlName="schedule" inputId="option1"></p-radioButton>
                        <label for="city1">
              <i class="pi pi-play p-mr-2"></i>Resume
            </label>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton [disabled]="qbDesktopDetails?.isSecheduled && qbDesktopDetails?.pausedOn!=null" value="Pause" formControlName="schedule" inputId="option2"></p-radioButton>
                        <label for="city2">
                <i class="pi pi-pause p-mr-2"></i>Pause
              </label>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displaySchedule=false;" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="setSchedular(schedularForm.value)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Multi Warehouse Setup" [(visible)]="displayTerms" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="header">
        <h5>Warehouse Count</h5>
    </div>
    <div class="card">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-6">
                <label>Number of QB Warehouses <span style="color:red">*</span></label>
            </div>
            <div class="p-col-12 p-md-6">
                <p-dropdown appendTo="body" [options]="warehouseCount" [(ngModel)]="selectedCount" [ngModelOptions]="{standalone: true}" placeholder="Select QB Fields"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="header">
        <h5>Terms and Conditions</h5>
    </div>
    <div class="card">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p>Content ...</p>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <div class="p-field-checkbox">
                    <p-checkbox [(ngModel)]="agreed" [binary]="true" inputId="binary"></p-checkbox>
                    <label for="binary">I agree...</label>
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayTerms=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="saveSetup()" [disabled]="!selectedCount || !agreed"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Multi Warehouse Setup" [(visible)]="displayQBMode" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="header">
        <h5>Warehouse Count</h5>
    </div>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-5 p-md-3">
                <p><strong>Number of QB Warehouses: </strong></p>
            </div>
            <div class="p-col-7 p-md-3">
                <p>{{selectedCount}}</p>
            </div>
            <div class="p-col-5 p-md-3">
                <p><strong>Multi Warehouse: </strong></p>
            </div>
            <div class="p-col-7 p-md-3">
                <button pButton icon="pi pi-check" label="Active" iconPos="right" (click)="confirm2()" *ngIf="isMultiple"></button>
                <button pButton icon="pi pi-times" class="p-button-outlined p-button-secondary" label="InActive" iconPos="right" (click)="confirm2()" *ngIf="!isMultiple"></button>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayQBMode=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="saveSetup2()"></button>
    </p-footer>
</p-dialog>
